<div class="login-error-page">
  <div class="login-error-panel">
    <header>
      <img src="./assets/img/logo.webp" class="logo" alt="NIMMSTA" />
    </header>
    <main class="login-error-message" aria-labelledby="login-error-title">
      <div class="login-error-icon" aria-hidden="true">
        <span class="material-icons">lock_outline</span>
      </div>
      <h1 id="login-error-title">{{ 'login-error.title' | translate }}</h1>
      <p class="login-error-description">
        {{ 'login-error.message' | translate }}
      </p>
      <a class="btn btn-outline-primary" href="/">{{
        'login-error.retry' | translate
      }}</a>
      @if (errorCode || errorDescription) {
        <div class="error-details">
          @if (errorCode) {
            <div>
              <span>{{ 'login-error.code' | translate }}:</span>
              <code>{{ errorCode }}</code>
            </div>
          }
          @if (errorDescription) {
            <div>
              <span>{{ 'login-error.description' | translate }}:</span>
              <code>{{ errorDescription }}</code>
            </div>
          }
        </div>
      }
      <div class="login-error-support">
        <p>{{ 'login-error.support' | translate }}</p>
        <div class="support-actions">
          <a class="btn support-action" href="mailto:support@nimmsta.com"
            >support&#64;nimmsta.com</a
          >
          @if (feedbackAvailable) {
            <button #reportButton type="button" class="btn support-action">
              {{ 'login-error.report' | translate }}
            </button>
          }
        </div>
      </div>
    </main>
    <footer class="login-error-footer">
      <a
        [href]="'imprint.url' | translate"
        target="_blank"
        rel="noopener noreferrer"
        >{{ 'imprint.label' | translate }}</a
      >
      <span aria-hidden="true">·</span>
      <a
        [href]="'privacy.url' | translate"
        target="_blank"
        rel="noopener noreferrer"
        >{{ 'privacy.label' | translate }}</a
      >
      <span aria-hidden="true">·</span>
      <a
        [href]="'terms.url' | translate"
        target="_blank"
        rel="noopener noreferrer"
        >{{ 'terms.label' | translate }}</a
      >
    </footer>
  </div>
  <div class="login-error-product">
    <app-product-placement></app-product-placement>
  </div>
</div>
